import { Injectable } from 'angular-ts-decorators';

import { SpynlBase } from '@shared/app/scripts/services/spynl-base';
import type { IConfig } from '@shared/app/scripts/services/config';
import { Domain } from '@shared/app/scripts/services/domain';

/**
 * Service in the coreModule. It takes care of communication with reports
 * resource. Methods are inherited form {@link shared.spynlBase
 * spynlBase} service, and are documented there.
 */
@Injectable('report')
export class Report extends SpynlBase<Object> {
  protected location: string;

  constructor(
    $http: ng.IHttpService,
    $q: ng.IQService,
    sentry,
    domain: Domain,
    config: IConfig,
    standardErrorParser,
  ) {
    'ngInject';

    super($http, $q, sentry, domain, config, standardErrorParser, Object);
    this.location = '/reports';
  }
}
